<template>
  <transition name="fade">
    <div v-if="visible" class="fb-overlay">
      <div class="fb-modal" role="dialog" aria-modal="true">
        <template v-if="!sent">
          <h2>O que você precisa no dia a dia?</h2>
          <p class="muted">Marque o que mais toma o seu tempo fora do atendimento. Lemos cada resposta.</p>
          <div class="options">
            <label v-for="o in options" :key="o.value" :class="{ selected: answers.includes(o.value) }">
              <input v-model="answers" type="checkbox" :value="o.value" />
              {{ o.label }}
            </label>
          </div>
          <textarea
            v-model="comment"
            rows="3"
            placeholder="O que você registra depois de cada sessão, e o que faria você usar o Ordexa todos os dias? (opcional)"
          ></textarea>
          <div class="actions">
            <button type="button" class="btn-text" @click="close">Agora não</button>
            <button type="button" class="btn-send" :disabled="(!answers.length && !comment.trim()) || sending" @click="send">
              Enviar
            </button>
          </div>
        </template>
        <template v-else>
          <h2>Obrigado! 💙</h2>
          <p class="muted">Sua resposta já chegou. Se quiser conversar, é só escrever para suporte@ordexa.com.br.</p>
          <div class="actions">
            <button type="button" class="btn-send" @click="close">Fechar</button>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { track } from "@/utils/analytics";

// Opened by the founder's "o que você precisa" e-mail (?pesquisa=necessidades): the answers
// go to the feedback the team reads (kind "needs").
const OPTIONS = {
  fonoaudiologo: [
    { value: "evolucao", label: "Escrever a evolução de cada sessão" },
    { value: "relatorios", label: "Relatórios para escola, médico ou convênio" },
    { value: "plano_terapeutico", label: "Plano terapêutico e objetivos" },
    { value: "exercicios_casa", label: "Exercícios e orientações para casa / para os pais" },
    { value: "desempenho", label: "Registrar desempenho (acertos, pistas) e ver a evolução" },
    { value: "avaliacoes", label: "Avaliações e protocolos" },
    { value: "agenda_financeiro", label: "Agenda, faltas e financeiro" },
  ],
  default: [
    { value: "evolucao", label: "Escrever a evolução de cada sessão" },
    { value: "relatorios", label: "Relatórios e documentos" },
    { value: "agenda_financeiro", label: "Agenda, faltas e financeiro" },
    { value: "organizar", label: "Organizar fichas e histórico dos pacientes" },
  ],
};

export default {
  name: "ComponentNeedsSurvey",
  data() {
    return { visible: false, answers: [], comment: "", sending: false, sent: false };
  },
  computed: {
    role() {
      const c = this.$store.state.Companies.company || {};
      return c.professional_role || "";
    },
    options() {
      return OPTIONS[this.role] || OPTIONS.default;
    },
  },
  watch: {
    "$route.query.pesquisa": {
      immediate: true,
      handler(value) {
        if (value !== "necessidades") return;
        this.visible = true;
        track("needs_survey_open", { role: this.role });
        const { pesquisa, ...rest } = this.$route.query;
        this.$router.replace({ query: rest }).catch(() => {});
      },
    },
  },
  methods: {
    async send() {
      this.sending = true;
      try {
        await axios.post("/api/v1/billing/feedback", {
          kind: `needs_${this.role || "outro"}`,
          answer: this.answers.join(",") || "texto",
          comment: this.comment.trim(),
          meta: { contentType: "application/json" },
        });
        track("needs_survey_sent", { role: this.role, count: this.answers.length });
        this.sent = true;
      } catch (e) {
        this.visible = false;
      } finally {
        this.sending = false;
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.fb-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 30, 40, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1900;
  padding: 16px;
}

.fb-modal {
  background: #fff;
  border-radius: 14px;
  max-width: 480px;
  width: 100%;
  padding: 1.7em;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.fb-modal h2 {
  margin: 0 0 0.5em;
  font-size: 1.3em;
  color: #222;
}

.muted {
  color: #555;
  line-height: 1.5;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  margin: 1em 0;
}

.options label {
  border: 1px solid #dde3e6;
  border-radius: 8px;
  padding: 0.6em 0.8em;
  cursor: pointer;
}

.options label.selected {
  border-color: #29b1cc;
  background: #f0fbfd;
}

.options input {
  margin-right: 0.5em;
}

textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccd3d8;
  border-radius: 8px;
  padding: 0.6em;
  font-family: inherit;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.8em;
  margin-top: 1em;
}

.btn-text {
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
}

.btn-send {
  background: #29b1cc;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.6em 1.4em;
  font-weight: 700;
  cursor: pointer;
}

.btn-send:disabled {
  opacity: 0.6;
}
</style>
